import React from 'react';

const SvgGroupInvitation: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-3 -4 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#428FEF"
      d="M15.386.01a.515.515 0 0 1 .604.604l-.019.07-1.348 3.847-.043.094a.515.515 0 0 1-.928-.435l.6-1.716-6.387 6.388 2.309 5.197.144-.437.043-.095a.515.515 0 0 1 .935.417l-.562 1.703a.514.514 0 0 1-.959.048L6.861 9.138.306 6.225a.515.515 0 0 1 .039-.956L15.315.03l.07-.02ZM1.909 5.81l5.228 2.324 6.39-6.39L1.908 5.812Z" // eslint-disable-line max-len
    />
    <path
      fill="#FF6661"
      d="M14.5 9.42h3.15v4.3a9.005 9.005 0 0 1-1.48.36c-.51.07-1.025.103-1.54.1a3.85 3.85 0 0 1-3-1.15 4.6 4.6 0 0 1-1.06-3.25 4.35 4.35 0 0 1 1.17-3.28 4.53 4.53 0 0 1 3.28-1.16 6.4 6.4 0 0 1 2.54.51l-.49 1.17a5 5 0 0 0-2.09-.48 2.8 2.8 0 0 0-2.17.86 3.33 3.33 0 0 0-.79 2.35 3.5 3.5 0 0 0 .72 2.39 2.56 2.56 0 0 0 2.06.82 7 7 0 0 0 1.45-.17v-2.17H14.5v-1.2Z" // eslint-disable-line max-len
    />
  </svg>
);

export default SvgGroupInvitation;
